import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { TenantModel } from '@core/services/api.service';
import { LoadTenantsAction, LoadTenantsSuccessAction, LoadTenantsFailAction } from './tenants.actions';
import { Injectable } from '@angular/core';
import { TenantsClient } from '@core/services/api.service';

export class TenantsStateModel {
  public isLoading: boolean;
  public tenants: TenantModel[];
}

@State<TenantsStateModel>({
  name: 'tenants',
  defaults: {
    isLoading: false,
    tenants: [],
  }
})
@Injectable()
export class TenantsState {
  constructor(
    private tenantsClient: TenantsClient
  ) { }

  @Selector()
  static getIsLoading(state: TenantsStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getTenants(state: TenantsStateModel) {
    return state.tenants;
  }

  @Action(LoadTenantsAction)
  loadTenantsAction({ dispatch, patchState }: StateContext<TenantsStateModel>, action: LoadTenantsAction) {
    patchState({ isLoading: true });

    return this.tenantsClient.getAll(false).pipe(
      tap((tenants) => dispatch(new LoadTenantsSuccessAction({ tenants }))),
      catchError((err) => dispatch(new LoadTenantsFailAction()))
    );
  }

  @Action(LoadTenantsSuccessAction)
  LoadTenantsSuccessAction(ctx: StateContext<TenantsStateModel>, action: LoadTenantsSuccessAction) {
    ctx.patchState({
      isLoading: false,
      tenants: action.payload.tenants
    });
  }

  @Action(LoadTenantsFailAction)
  loadTenantsFailAction(ctx: StateContext<TenantsStateModel>, action: LoadTenantsFailAction) {
    ctx.patchState({
      isLoading: false,
      tenants: []
    });
  }
}
